import { Injectable, EventEmitter } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse
} from '@angular/common/http';
import { Router } from '@angular/router';
import {
  Subject,
  Observable,
  throwError as observableThrowError,
  of
} from 'rxjs';

import {
  MyHttpService,
  LoaderService
} from 'potscommonui/src/app/component-library';
import { environment } from 'src/environments/environment';
import { finalize, map, catchError } from 'rxjs/operators';
import { GuestService } from './guest.service';
import { SharedService } from './shared.service';
// import { DataService } from './data.service';
// import { LSRUIJson } from '../class/lsruiJson';
// import { PanelistService } from './panelist.service';

@Injectable({ providedIn: 'root' })
export class AuthService extends MyHttpService {
  sessionId: string;
  sessionId2: string;
  profilePage = '';
  passwordChange: string;
  passwordCreate: string;
  profilePageLoaded = '';
  private isAuthenticated = false;
  private token: string;
  private expirationDate;
  private tokenTimer: any;
  private authStatusListener = new Subject<{
    isAuthenticated: boolean;
    section: string;
  }>();

  private preSignupMobileVerifyUrl = '../lsrsdp/pre-signup-mobile-verify';

  private authenticatUrl = '../lsrsdp/authenticate';

  private logOutUrl = '../lsrsdp/logout';

  private postheader = new HttpHeaders({ 'Content-Type': 'application/json' });

  controlLoader = new EventEmitter<boolean>();

  constructor(
    httpclient: HttpClient,
    loaderService: LoaderService,
    private guestService: GuestService,
    private sharedService: SharedService,
    private router: Router
  ) {
    super(httpclient, loaderService);
  }

  getToken() {
    return this.token;
  }

  setToken(tokenNew: string) {
    this.token = tokenNew;
  }
  getExpirationDate() {
    return this.expirationDate;
  }
  setExpirationDate(val: Date) {
    this.expirationDate = val;
  }

  getIsLoggedIn() {
    return this.isAuthenticated;
  }

  getLoggedInListener() {
    return this.authStatusListener.asObservable();
  }

  preSignupMobileVerify(requestBody): Observable<any> {
    this.controlLoader.emit(true);
    this.clearAuthData();
    const returnVal: Observable<any> = this.http
      .post(this.preSignupMobileVerifyUrl, requestBody, {
        headers: this.postheader,
        observe: 'response'
      })
      .pipe(
        finalize(() => {
          this.controlLoader.emit(false);
        }),
        map(el => {
          if (el.status === 200) {
            // this.token = el.body ? (el.body as any).token : 0;
            // const expiresInDuration: any = el.body
            //   ? (el.body as any).expiresIn
            //   : 0;
            // this.setAuthTimer(expiresInDuration);
            this.isAuthenticated = true;
            this.authStatusListener.next({
              isAuthenticated: true,
              section: 'Registration'
            });
            // const now = new Date();
            // const expirationDate = new Date(
            //   now.getTime() + expiresInDuration * 1000
            // );
            // //console.log(expirationDate);
            // this.saveAuthData(token, expirationDate);
          }
          return el.body;
        }),
        catchError(this.handleErrorLocal)
      );

    return returnVal;
  }
  authenticateSignup(requestBody): Observable<any> {
    this.controlLoader.emit(true);

    this.clearAuthData();
    const returnVal: Observable<any> = this.http
      .put(this.authenticatUrl, requestBody, {
        headers: this.postheader,
        observe: 'response'
      })
      .pipe(
        finalize(() => {
          this.controlLoader.emit(false);
        }),
        map(el => {
          if (
            el.status === 200 &&
            (el.body as any).message === 'Authentication Successful'
          ) {
            this.token = el.body ? (el.body as any).token : '';
            const expiresInDuration: any = el.body
              ? (el.body as any).expiresIn
              : 0;
            this.setAuthTimer(expiresInDuration);
            // set access
            this.isAuthenticated = true;
            if ((el.body as any).role !== 'interviewer') {
              this.authStatusListener.next({
                isAuthenticated: true,
                section: 'Interviewer'
              });
            }
            if ((el.body as any).pegaHouseholdId) {
              this.authStatusListener.next({
                isAuthenticated: true,
                section: 'Profile'
              });
            } else {
              this.authStatusListener.next({
                isAuthenticated: true,
                section: 'Registration'
              });
            }

            // set token expiration
            const now = new Date();
            // console.log(now.getTime);
            this.expirationDate = new Date(
              now.getTime() + expiresInDuration * 1000
            );
            // console.log(this.expirationDate);
            // this.saveAuthData(this.token, this.expirationDate);
          }
          return el.body;
        }),
        catchError(this.handleErrorLocal)
      );
    return returnVal;
  }

  authenticate(requestBody): Observable<any> {
    this.controlLoader.emit(true);

    this.clearAuthData();
    const returnVal: Observable<any> = this.http
      .post(this.authenticatUrl, requestBody, {
        headers: this.postheader,
        observe: 'response'
      })
      .pipe(
        finalize(() => {
          this.controlLoader.emit(false);
        }),
        map(el => {
          if (
            el.status === 200 &&
            (el.body as any).message === 'Authentication Successful'
          ) {
            this.token = el.body ? (el.body as any).token : '';
            const expiresInDuration: any = el.body
              ? (el.body as any).expiresIn
              : 0;
            this.setAuthTimer(expiresInDuration);
            // set access
            this.isAuthenticated = true;
            if ((el.body as any).role !== 'interviewer') {
              this.authStatusListener.next({
                isAuthenticated: true,
                section: 'Interviewer'
              });
            }
            if ((el.body as any).pegaHouseholdId) {
              this.authStatusListener.next({
                isAuthenticated: true,
                section: 'Profile'
              });
            } else {
              this.authStatusListener.next({
                isAuthenticated: true,
                section: 'Registration'
              });
            }

            // set token expiration
            const now = new Date();
            // console.log(now.getTime);
            this.expirationDate = new Date(
              now.getTime() + expiresInDuration * 1000
            );
            // console.log(this.expirationDate);
            // this.saveAuthData(this.token, this.expirationDate);
          }
          return el.body;
        }),
        catchError(this.handleErrorLocal)
      );
    return returnVal;
  }

  login(val: string) {
    this.isAuthenticated = true;
    this.authStatusListener.next({
      isAuthenticated: true,
      section: val
    });
  }

  autoAuthUser() {
    const authInformation = this.getAuthData();
    if (!authInformation) {
      return;
    }

    const now = new Date();
    const expiresIn = authInformation.expirationDate.getTime() - now.getTime();
    if (expiresIn > 0 && authInformation.token != null) {
      this.token = authInformation.token;
      this.isAuthenticated = true;
      this.setAuthTimer(expiresIn / 1000);
      this.authStatusListener.next({ isAuthenticated: true, section: '' });
      this.clearAuthData();
    }
  }

  logout(val?: boolean) {
    if (val == null) {
      val = true;
    }
    const request = {
      userName: this.guestService.username.toLowerCase(),
      countryId: 39,
      sessionId: this.sessionId
    };
    this.http
      .post(this.logOutUrl, request, {
        headers: this.postheader,
        observe: 'response'
      })
      .pipe(
        finalize(() => {
          this.guestService.username = '';
          this.sharedService.userName = '';

          this.controlLoader.emit(false);
        }),
        map(el => {
          if (el.status === 200) {
            this.token = null;
            this.isAuthenticated = false;
            this.profilePageLoaded = 'Home';
            this.profilePage = 'Home';
            this.authStatusListener.next({
              isAuthenticated: false,
              section: ''
            });
          }
          return el.body;
        }),
        catchError(this.handleErrorLocal)
      )
      .subscribe(
        res => {
          clearTimeout(this.tokenTimer);
          this.passwordChange = 'false';
          this.passwordCreate = 'false';
          this.clearAuthData();
          if (val) {
            if (this.sharedService.isRDD) {
              this.router.navigate(['sdp/rddsignin']);
            } else if (this.sharedService.isInterviewer) {
              this.router.navigate(['sdp/interviewersignin']);
            } else {
              this.router.navigate(['sdp/signin']);
            }
          }
        },
        err => {
          // console.log(err);
        }
      );
  }

  uilogout() {
    this.token = null;
    this.isAuthenticated = false;
    this.authStatusListener.next({
      isAuthenticated: false,
      section: ''
    });

    clearTimeout(this.tokenTimer);
    this.clearAuthData();
  }

  // autoAuthEvent() {
  //   this.authStatusListener.next({
  //     isAuthenticated: true,
  //     section: 'Load Data'
  //   });
  // }

  setAuthTimer(duration: number) {
    // console.log('Setting timer: ' + duration);
    this.tokenTimer = setTimeout(() => {
      this.logout();
      if (this.sharedService.isRDD) {
        this.router.navigate(['sdp/rddsignin']);
      } else if (this.sharedService.isInterviewer) {
        this.router.navigate(['sdp/interviewersignin']);
      } else {
        this.router.navigate(['sdp/signin']);
      }
    }, duration * 1000);
  }

  clearAuthTimer() {
    clearTimeout(this.tokenTimer);
  }

  saveAuthData(token: string, expirationDate: Date) {
    localStorage.setItem('token', token);
    localStorage.setItem('expiration', expirationDate.toISOString());
    localStorage.setItem('sessionId', this.sessionId);
    localStorage.setItem('profilePage', this.profilePage);
    localStorage.setItem('passwordChange', this.passwordChange);
    localStorage.setItem('passwordCreate', this.passwordCreate);
  }

  clearAuthData() {
    localStorage.removeItem('token');
    localStorage.removeItem('expiration');
    localStorage.removeItem('sessionId');
    localStorage.removeItem('profilePage');
    localStorage.removeItem('passwordChange');
    localStorage.removeItem('passwordCreate');
  }

  private getAuthData() {
    const token = localStorage.getItem('token');
    const expirationDate = localStorage.getItem('expiration');
    this.setExpirationDate(new Date(expirationDate));
    this.sessionId = localStorage.getItem('sessionId');
    this.profilePageLoaded = localStorage.getItem('profilePage');

    this.passwordChange = localStorage.getItem('passwordChange');
    this.passwordCreate = localStorage.getItem('passwordCreate');
    // console.log(this.passwordChange);
    if (!token || !expirationDate) {
      return;
    }
    return {
      token: token,
      expirationDate: new Date(expirationDate)
    };
  }

  private handleErrorLocal(error: HttpErrorResponse | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof HttpErrorResponse) {
      errMsg = `${error.status} - ${error.statusText || ''} @ ${error.url
        }\n${JSON.stringify(error)}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return observableThrowError(error);
  }
}
